/* Custom variant dropdown behavior. Delegated so it works for every .csel
   on the page (product cards + product page), including hover-revealed ones. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('.csel.is-open').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-open');
      var b = c.querySelector('.csel__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  // Formats a whole-cents integer using the shop's configured money format
  // (window.themeMoneyFormat, set in layout/theme.liquid), so displayed
  // totals match Shopify's own currency formatting instead of a hardcoded one.
  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/amount_no_decimals/.test(format)) {
      return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas);
    }
    return format.replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  // Given a .pdp__qty element, finds the nearest price display in the same
  // product form/card and updates it to unit price × quantity.
  function syncQtyPrice(qtyEl) {
    if (!qtyEl) return;
    var container = qtyEl.closest('.fp__buy, .pdp__info-inner') || qtyEl.closest('form');
    if (!container) return;
    var priceEl = container.querySelector('.pdp__price[data-price], .fp__addprice[data-price]');
    if (!priceEl) return;
    var unitCents = parseInt(priceEl.getAttribute('data-unit-cents'), 10);
    if (!unitCents) return;
    var input = qtyEl.querySelector('.pdp__qty-input');
    var qty = Math.max(1, parseInt(input && input.value, 10) || 1);
    priceEl.textContent = formatMoney(unitCents * qty);
  }
  window.syncQtyPrice = syncQtyPrice;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.csel__btn');
    var opt = e.target.closest('.csel__opt');

    if (btn) {
      e.preventDefault();
      var csel = btn.closest('.csel');
      var willOpen = !csel.classList.contains('is-open');
      closeAll(csel);
      csel.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (opt) {
      e.preventDefault();
      if (opt.classList.contains('is-disabled')) return;
      var wrap = opt.closest('.csel');
      wrap.querySelectorAll('.csel__opt').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-selected', 'true');

      var valueEl = wrap.querySelector('.csel__value');
      if (valueEl) valueEl.textContent = opt.dataset.label;

      var input2 = wrap.querySelector('[data-csel-input]');
      if (input2) input2.value = opt.dataset.value;

      // Update the nearest price display (product card bar or PDP price),
      // scoped specifically to .pdp__price/.fp__addprice — NOT a generic
      // [data-price] selector, which would also match the dropdown options
      // themselves (they carry their own data attributes) and silently
      // write into the wrong element.
      var container = wrap.closest('.fp__buy, .pdp__info-inner') || wrap.closest('form');
      var priceEl = container && container.querySelector('.pdp__price[data-price], .fp__addprice[data-price]');
      if (priceEl && opt.dataset.variantCents) {
        priceEl.setAttribute('data-unit-cents', opt.dataset.variantCents);
        var qtyEl = container.querySelector('.pdp__qty');
        if (qtyEl) {
          syncQtyPrice(qtyEl);
        } else if (opt.dataset.variantPrice) {
          priceEl.textContent = opt.dataset.variantPrice;
        }
      }

      // Toggle the "Running Low" badge to match the newly selected variant.
      var badgeEl = container && container.querySelector('[data-stock-badge]');
      if (badgeEl) {
        badgeEl.hidden = opt.dataset.variantLow !== '1';
      }

      wrap.classList.remove('is-open');
      var b = wrap.querySelector('.csel__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
      return;
    }

    // click outside any dropdown
    closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
